import React from "react";
import { ProgressBar } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { format } from "date-fns";

import { getBadgeImage, getCountryLabel } from "./utils/BadgeImages";

/**
 * Jeden odznak. Vo variante "tile" sa zobrazuje celá kartička do vitríny,
 * vo variante "icon" iba obrázok s tooltipom (mini-lišta v profile a upozornenia).
 */
export default function AchievementBadge({ achievement, variant = "tile", size = 78, tooltipId = "achievementTooltip" }) {
    let image = getBadgeImage(achievement.icon);
    let earned = achievement.earned;

    let tooltip = earned
        ? `${achievement.name} – získané${achievement.awarded ? ' ' + format(new Date(achievement.awarded), 'dd.MM.yyyy') : ''}`
        : `${achievement.name} – ${achievement.description}`;

    //ak by backend poslal odznak, na ktorý tu ešte nie je obrázok, zobrazí sa neutrálna medaila
    let badgeImage = image ? (
        <img
            src={image}
            alt={achievement.name}
            width={size}
            height={size}
            className={`achievementBadgeImage ${earned ? '' : 'locked'}`}
            data-tooltip-id={tooltipId}
            data-tooltip-content={tooltip}
        />
    ) : (
        <FontAwesomeIcon
            icon="fa-solid fa-medal"
            className={`achievementBadgeImage color-kuzel ${earned ? '' : 'locked'}`}
            style={{ width: size, height: size }}
            data-tooltip-id={tooltipId}
            data-tooltip-content={tooltip}
        />
    );

    if (variant === "icon") {
        return (
            <span className="achievementBadgeIcon">
                {badgeImage}
                {achievement.count > 1 && (
                    <span className="achievementBadgeCount">{achievement.count}</span>
                )}
            </span>
        );
    }

    // pri binárnych odznakoch (cieľ = 1) by progress bar nemal žiadnu informačnú hodnotu
    let showProgress = !earned && achievement.target > 1;
    let progressPercent = achievement.target > 0 ? Math.min(100, Math.round(achievement.progress / achievement.target * 100)) : 0;

    return (
        <div className={`achievementBadge ${earned ? 'earned' : 'locked'}`}>
            <div className="achievementBadgeImageWrapper">
                {badgeImage}
                {achievement.count > 1 && (
                    <span className="achievementBadgeCount">{achievement.count}</span>
                )}
            </div>

            <div className="achievementBadgeName">{achievement.name}</div>

            <div className="achievementBadgeText">{achievement.description}</div>

            {earned ? (
                <div className="achievementBadgeEarned">
                    {achievement.awarded ? format(new Date(achievement.awarded), 'dd.MM.yyyy') : 'Získané'}
                </div>
            ) : showProgress ? (
                <div className="achievementBadgeProgress">
                    <ProgressBar now={progressPercent} />
                    <small>{achievement.progress} / {achievement.target}</small>
                </div>
            ) : (
                <div className="achievementBadgeEarned notEarnedYet">Zatiaľ nezískané</div>
            )}

            {earned && achievement.variants && achievement.variants.length > 0 && (
                <div className="achievementBadgeVariants">
                    {achievement.variants.map(code => (
                        <span key={code} className="achievementBadgeVariant">{getCountryLabel(code)}</span>
                    ))}
                </div>
            )}
        </div>
    );
}
